import useViewModel from "./viewModel";
import View from "./view";

export default function PaymentSuccess() {
  const vm = useViewModel();
  return <View {...vm} />;
}
